var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['navigationBar', _vm.color ? (_vm.color + "Buttons") : '', _vm.fixed ? 'fixed' : '']},[_c('CloseButton',{attrs:{"theme":_vm.theme}}),_c('ShareButton',{attrs:{"theme":_vm.theme}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }